import { useCallback, useContext, useEffect, useState } from "react";
import { ConfigContext } from "./ConfigContext";

export function usePurchaseEntry() {

    const { Config, getCompany, getPartyList } = useContext(ConfigContext);

    const [Products, setProducts] = useState([])
    const [partyName, setpartyName] = useState('')
    const [partyContact, setpartyContact] = useState('')
    const [partyDetails, setpartyDetails] = useState('')
    const [partyGST, setPartyGST] = useState('')
    const [AmtPaid, setAmtPaid] = useState(0);
    const [date, setDate] = useState(Date());
    const [CustomerList, setCustomerList] = useState([]);
    let [Company, setCompany] = useState({});
    /** Clears the form inputs */
    const clearAll = useCallback(() => {
        setpartyDetails('');
        setpartyContact('');
        setpartyName('');
        setPartyGST('')
        setProducts([]);
        setAmtPaid(0);
        setDate(Date());
        setCustomerList([]);
        setCompany({});
    }, [])

    useEffect(() => {
        getPartyList().then((res) => {
            setCustomerList(res);
        })

        getCompany().then((res) => {
            setCompany(res);
        })
        return () => {
            clearAll();
        }
    }, [clearAll, getCompany, getPartyList]);

    function aggregateTotals() {
        // calucate subtotal & total
        let subTotal = 0;
        if (Products.length) {
            subTotal = Products.reduce((sum, product) => {
                let totalsum = sum + product.amount;
                return totalsum
            }, 0)
        }

        let gstTotal = 0;
        if (Products.length) {
            gstTotal = Products.reduce((sum, product) => {
                let totalsum = sum + product.gstAmt;

                return totalsum
            }, 0)
        }

        let total = subTotal;
        if (Config.gst.enabled) {
            total = subTotal + gstTotal;
        }

        return {
            subTotal, gstTotal, total
        }
    }

        /** Add Product to table */
        const addProduct = (item) => {
            setProducts([...Products, item])
            setAmtPaid(AmtPaid + parseFloat(item.total));
        }

        /** Remove product item by id
     * @param id
     * @param pname Product Name
     * @param quan - Quantity
     */
    const removeProduct = (id) => {
        let pLeft = Products.filter(product => (product.id !== id))
        let p = Products.find(product => (product.id === id))
        setProducts(pLeft)
        setAmtPaid(AmtPaid - parseFloat(p.total || 0));
    }
    



    return {
        Products, setProducts, 
        partyName, setpartyName,
        partyContact, setpartyContact,
        partyDetails, setpartyDetails,
        partyGST, setPartyGST,
        date, setDate,
        AmtPaid, setAmtPaid,
        Config,
        CustomerList, setCustomerList,
        Company,

        aggregateTotals, addProduct , clearAll, removeProduct,


    }
}